import { Link } from 'react-router-dom';
import MangaCard from '@/components/feature/MangaCard';
import { getHotManga } from '@/mocks/manga';

export default function HotRecommendations() {
  const hotManga = getHotManga(6);

  return (
    <section className="py-10 md:py-14 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-6">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
              热门推荐
            </h2>
            <p className="text-foreground-500 text-sm mt-1">大家都在看的腐漫精选</p>
          </div>
          <Link
            to="/category/hanman-danmei"
            className="text-sm text-accent-600 hover:text-accent-700 font-medium flex items-center gap-1 whitespace-nowrap"
          >
            查看全部
            <i className="ri-arrow-right-line text-xs"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4">
          {hotManga.map((manga) => (
            <MangaCard key={manga.id} manga={manga} />
          ))}
        </div>
      </div>
    </section>
  );
}